import script from "./SessionImageCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionImageCapture.vue?vue&type=script&setup=true&lang=js"

import "./SessionImageCapture.vue?vue&type=style&index=0&id=191c4c78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191c4c78"]])

export default __exports__